/** Cargo desde getCargos */
export type Cargo = {
  id: number
  nombre: string
  descripcion: string
  estado: boolean
}

/** Contacto desde getSocio / upsertContacto (campos opcionales según versión del API) */
export type ContactoSocio = {
  id: number
  nombre: string
  email?: string
  telefono?: string
  cargo?: string
  idCargo?: number
  observaciones?: string
  apellido?: string
  documento_identidad?: string
  empresa_id?: number
  miembro_id?: number
  activo?: number
  es_admin?: number
  principal?: boolean
  fecha_creado?: string
  fecha_modificado?: string
}

export type ContactoPrincipalFields = {
  contactoNombre: string
  contactoEmail: string
  contactoTelefono: string
}

const norm = (s: string) => (s || '').trim().toLowerCase()
const normTel = (s: string) => (s || '').trim()

/** Indica si el contacto del array coincide con el contacto principal del socio */
export function isContactoPrincipal(c: ContactoSocio, principal: ContactoPrincipalFields): boolean {
  const nombreOk = norm(c.nombre || '') === norm(principal.contactoNombre)
  if (!nombreOk) return false
  const emailOk = norm(c.email || '') === norm(principal.contactoEmail)
  const telOk = normTel(c.telefono || '') === normTel(principal.contactoTelefono)
  return emailOk && telOk
}

export function getContactosSecundarios(
  contactos: ContactoSocio[] | undefined,
  principal: ContactoPrincipalFields
): ContactoSocio[] {
  if (!contactos?.length) return []
  return contactos.filter((c) => {
    if (c.principal === true) return false
    if (c.activo !== undefined && c.activo !== 1) return false
    return !isContactoPrincipal(c, principal)
  })
}

export function nombreContactoCompleto(c: ContactoSocio): string {
  const ap = c.apellido?.trim()
  return ap ? `${c.nombre} ${ap}`.trim() : c.nombre
}
